import { render, staticRenderFns } from "./card.vue?vue&type=template&id=06c390b6&"
import script from "./card.js?vue&type=script&lang=js&"
export * from "./card.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports